/* eslint-disable prettier/prettier */
import React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
};

export const Button = ({
  variant = 'primary',
  className = '',
  disabled,
  size = 'md',
  isLoading = false,
  icon,
  iconPosition = 'left',
  children,
  ...props
}: ButtonProps) => {
  const hasText = !!children;

  const base =
    'inline-flex items-center justify-center rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed';

  const sizeClasses = hasText ? 'px-4 py-2' : 'p-2'; 

  const variants = {
    primary: 'bg-primary text-white hover:bg-secondary',
    secondary: 'bg-light text-primary hover:bg-muted',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    ghost: 'bg-transparent text-primary hover:bg-light',
  };

  return (
    <button
      disabled={disabled}
      className={`${base} ${sizeClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {isLoading && <div className="spinner" />} {/* Add spinner later if needed */}
      {!isLoading && icon && iconPosition === 'left' && <span className="mr-2">{icon}</span>}
      {children}
      {!isLoading && icon && iconPosition === 'right' && <span className="ml-2">{icon}</span>}
    </button>
  );
};

